<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import type { RawSvg } from "vite-plugin-magical-svg";

	interface Props {
		icon: RawSvg;
		size?: string;
		class?: ClassValue;
		alt?: string;
	}

	const { icon, size, alt, class: classes }: Props = $props();
</script>

<svg class={classes} width={size} height={size}>
	{#if alt}<title>{alt}</title>{/if}
	{@html icon.raw}
</svg>

<style>
	:root {
		--s-icon-default: 1.5rem;
	}

	svg:not([width]) {
		inline-size: var(--icon-size, var(--s-icon-default));
	}

	svg:not([height]) {
		block-size: var(--icon-size, var(--s-icon-default));
	}
</style>
